import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1E1E1E",
      d: "M12.33 19.3a.727.727 0 0 1-.55-.225L5.155 12.45a.62.62 0 0 1-.2-.45.62.62 0 0 1 .2-.45.67.67 0 0 1 .45-.175q.25 0 .425.175l5.675 5.675V5a.6.6 0 0 1 .175-.45.6.6 0 0 1 .45-.175q.276 0 .45.187.176.188.176.463v12.2l5.674-5.675a.58.58 0 0 1 .425-.175q.25 0 .45.175a.62.62 0 0 1 .2.45.62.62 0 0 1-.2.45l-6.624 6.625a.73.73 0 0 1-.55.225"
    }, null, -1)
  ])))
}
export default { render: render }